import { useState } from 'react';
import { supabase } from '../supabaseClient';
import { colors } from '../styles/colors';

const AddGameForm = ({ onGameAdded }) => {
  const [title, setTitle] = useState('');
  const [releaseYear, setReleaseYear] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data, error } = await supabase
        .from('games')
        .insert([{ title, release_year: releaseYear || null }])
        .select()
        .single();
      if (error) throw error;

      onGameAdded(data);
      setTitle('');
      setReleaseYear('');
    } catch (err) {
      console.error('Error adding game:', err);
      alert('Error adding game');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        backgroundColor: colors.background,
        padding: '1rem',
        borderRadius: '12px',
        boxShadow: '0 8px 18px rgba(0,0,0,0.08)',
      }}
    >
      <h3 style={{ color: colors.primary, margin: 0 }}>Add New Game</h3>
      <input
        type="text"
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
        style={inputStyle}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <input
        type="number"
        placeholder="Release Year"
        value={releaseYear}
        onChange={(e) => setReleaseYear(e.target.value)}
        style={inputStyle}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <button
        type="submit"
        disabled={loading}
        style={{
          ...buttonStyle,
          opacity: loading ? 0.7 : 1,
          cursor: loading ? 'not-allowed' : 'pointer',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = colors.buttonHover)}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = colors.button)}
      >
        {loading ? 'Adding...' : 'Add Game'}
      </button>
    </form>
  );
};

const inputStyle = {
  padding: '0.5rem 0.75rem',
  borderRadius: '8px',
  border: `1px solid #ccc`,
  outline: 'none',
  fontSize: '0.95rem',
  transition: 'border-color 0.2s, box-shadow 0.2s',
};

const buttonStyle = {
  padding: '0.6rem 1rem',
  borderRadius: '8px',
  border: 'none',
  backgroundColor: colors.button,
  color: '#fff',
  fontWeight: '600',
  fontSize: '0.95rem',
  transition: 'background-color 0.3s, transform 0.2s',
};

const onFocus = (e) => {
  e.currentTarget.style.borderColor = colors.buttonHover;
  e.currentTarget.style.boxShadow = `0 0 5px ${colors.buttonHover}80`;
};
const onBlur = (e) => {
  e.currentTarget.style.borderColor = '#ccc';
  e.currentTarget.style.boxShadow = 'none';
};

export default AddGameForm;